import { planningAPI } from "../../axios";

export const actions = {
    // PlanningModeOfVerification
    GetMOVByTarget(context, data){
        return planningAPI.get(`PlanningModeOfVerification/PlanningTarget/${data}`);
    },
    GetSingleMOV(context, data){
        return planningAPI.get(`PlanningModeOfVerification/${data}`);
    },
    CreateMOV(context, data){
        return planningAPI.post(`PlanningModeOfVerification/Create`, data);
    },
    UpdateMOV(context, data){
        return planningAPI.put(`PlanningModeOfVerification/Update/${data.id}`, data);
    },
    DeleteMOV(context, data){
        return planningAPI.delete(`PlanningModeOfVerification/Remove/${data}`);
    },
}
